"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lineHeights = void 0;
exports.lineHeights = {
    lineHeight1: 16,
    lineHeight2: 20,
    lineHeight3: 22,
    lineHeight4: 24,
    lineHeight5: 32,
    lineHeight6: 40,
    lineHeight7: 56,
};
//# sourceMappingURL=lineHeights.js.map